export default __webpack_public_path__ + "static/media/chien_abime.53cd50f3.jpg";